import { FaHotel } from "react-icons/fa";
import { defineType } from "sanity";
import { multilingualStringPreview } from "../base/multilingualArrayString";

export default defineType({
  title: "Find Your Hotel",
  name: "fyh",
  type: "object",
  icon: FaHotel,
  fields: [
    {
      name: "title",
      title: "Title",
      type: "multilingualArrayString"
    }
  ],
  preview: {
    select: {
      title: "title"
    },
    prepare(selection) {
      const { title } = selection;
      const previewTitle = multilingualStringPreview(title);
      return {
        title: previewTitle || "(Find Your Hotel)"
      };
    }
  }
});
